module.exports = __webpack_public_path__ + "img/snap-graphick.e1f8fd6c.svg";